export default __webpack_public_path__ + "static/media/doc.3977eb0b.svg";